import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

import { SubscriptionState } from '@shared/recurly/enums';
import { PaymentPlanCodes } from '@shared/price-plan/enums';
import { PricePlan } from '@shared/price-plan/models';
import { PLAN_TIERS, PLANS_BENEFITS } from '../../constants';
import { AppIcon, AppIconColor } from '@tablesready/frontend-icons';

@Component({
  selector: 'free-plan',
  templateUrl: './free-plan.component.html',
  styleUrls: ['../../scss/plan-cards.scss'],
})
export class FreePlanComponent implements OnDestroy {
  @Input() currentPricePlan: PricePlan;
  @Input() selectedPlan: PricePlan;
  @Input() blockActions = false;
  @Input() subscriptionState: SubscriptionState;
  @Input() canceledSubscription = false;
  @Output() updateSubscription = new EventEmitter<string>();

  icon = AppIcon;
  planTiers = PLAN_TIERS;
  benefits = PLANS_BENEFITS;
  iconColor = AppIconColor;

  get showCurrentPlanBtn(): boolean {
    return this.currentPricePlan.plan_code === PaymentPlanCodes.Free;
  }

  get disableDowngradeBtn(): boolean {
    return this.subscriptionState === SubscriptionState.paused ||
      this.subscriptionState === SubscriptionState.canceled ||
      this.canceledSubscription ||
      this.blockActions;
  }

  ngOnDestroy(): void {
    this.updateSubscription.complete();
  }
}
